<template>
  <q-tab :key="name" :name="name" :label="label" :icon="icon" no-caps>
    <slot />
  </q-tab>
</template>

<script>
/*
 * items: {value: String, label: String, icon: String}
 */

export default {
  name: 'Tab',
  props: {
    name: {
      type: String,
    },
    label: {
      type: String,
    },
    icon: {
      type: String,
    },
  },
};
</script>

<style scoped></style>
